const noScroll = require('@alexspirgel/no-scroll');
const svgSearch = require('../../../assets/icons/search.svg').default;

module.exports = class SiteWideHeader {

	static get mediaQuery() {
		return {
			medium: window.matchMedia('(max-width: 48rem)'), // 768px
			large: window.matchMedia('(max-width: 80rem)'), // 1280px
		};
	}

	static waitForElement(selector) {
		return new Promise(resolve => {
			if (document.querySelector(selector)) {
				return resolve(document.querySelector(selector));
			}
			const observer = new MutationObserver(mutations => {
				if (document.querySelector(selector)) {
					observer.disconnect();
					resolve(document.querySelector(selector));
				}
			});
			observer.observe(document, {
				childList: true,
				subtree: true,
			});
		});
	}

	static get noScrollOptions() {
		return {
			outerElement: document.documentElement,
			innerElement: document.body,
			axis: 'y'
		}
	}

	constructor() {
		this.initialize();
	}

	async initialize() {
		if (!this.initialized) {

			this.initialized = true;
			await this.constructor.waitForElement('.page-content');

			// get elements
			this.utilityMenuBlockElement = document.querySelector('#block-utilitymenu');
			this.utilityMenuElement = this.utilityMenuBlockElement.querySelector(':scope > .utility-menu');
			this.utilitySearchButtonElement = document.querySelector('.utility-menu__link.search');
			this.searchBlockElement = document.querySelector('#block-exposedformglobal-searchglobal-search');
			this.searchFormInputElement = this.searchBlockElement.querySelector('.form-text');
			this.searchFormSubmitWrapperElement = this.searchBlockElement.querySelector('.form-actions');
			this.searchFormSubmitElement = this.searchBlockElement.querySelector('.form-submit');
			this.mainMenuBlockElement = document.querySelector('#block-mercy-hurst-main-menu');
			this.mainMenuListElement = this.mainMenuBlockElement.querySelector(':scope > ul');
			this.mainMenuItemLevel0Elements = this.mainMenuListElement.querySelectorAll(':scope > li');
			this.siteWideHeaderElement = document.querySelector('.dialog-off-canvas-main-canvas > header');
			this.mobileSearchButtonElement = document.querySelector('.header-buttons__search-button');
			this.mobileNavButtonElement = document.querySelector('.header-buttons__menu-button');

			// desktop/mobile switch
			this.mediaQueryLargeListener(this.constructor.mediaQuery.large);
			this.constructor.mediaQuery.large.addListener(this.mediaQueryLargeListener);
			this.mediaQueryMediumListener(this.constructor.mediaQuery.medium);
			this.constructor.mediaQuery.medium.addListener(this.mediaQueryMediumListener);

			// insert svgs
			if (this.searchFormSubmitWrapperElement) {
				this.searchFormSubmitWrapperElement.insertAdjacentHTML('beforeend', svgSearch);
			}

			// update attributes
			this.searchFormInputElement.setAttribute('placeholder', 'Search Mercyhurst');

			// attach listeners
			this.addMobileEventListenersToLevel0Items();
			document.addEventListener('keydown', (event) => {
				if (event.key === 'Escape' && this.searchBlockElement.contains(document.activeElement)) {
					this.hideSearchBlock();
				}
			});
			this.utilitySearchButtonElement.addEventListener('click', () => {
				this.toggleSearchBlock();
			});
			this.mobileSearchButtonElement.addEventListener('click', this.toggleMobileSearch);
			this.mobileNavButtonElement.addEventListener('click', this.toggleMobileMenu);

			// set mega menu column count
			this.setMegaMenuColumnCounts();

			// set mega menu positions
			this.setMegaMenuPositions();
			window.addEventListener('resize', this.setMegaMenuPositions);

			// set mobile overlay height
			this.updateMobileOverlayHeight();
			window.addEventListener('resize', this.updateMobileOverlayHeight);

		}
	}

	mediaQueryLargeListener = (mediaQuery) => {
		if (mediaQuery.matches) {
			if (this.desktopMobileState !== 'mobile') {
				this.desktopMobileState = 'mobile';
				this.desktopMobileStateChange();
			}
		}
		else {
			if (this.desktopMobileState !== 'desktop') {
				this.desktopMobileState = 'desktop';
				this.desktopMobileStateChange();
			}
		}
	}

	desktopMobileStateChange() {
		if (this.desktopMobileState === 'desktop') {
			// switch to desktop
			this.closeMobileSearch();
			this.closeMobileMenu();
		}
		else if (this.desktopMobileState === 'mobile') {
			// switch to mobile
			this.hideSearchBlock();
		}
	}

	mediaQueryMediumListener = (mediaQuery) => {
		if (mediaQuery.matches) {
			if (this.utilityMenuState !== 'mobile') {
				this.utilityMenuState = 'mobile';
				this.utilityMenuStateChange();
			}
		}
		else {
			if (this.utilityMenuState !== 'desktop') {
				this.utilityMenuState = 'desktop';
				this.utilityMenuStateChange();
			}
		}
	}

	utilityMenuStateChange() {
		if (this.utilityMenuState === 'desktop') {
			// switch to desktop
			if (!this.utilityMenuBlockElement.contains(this.utilityMenuElement)) {
				this.utilityMenuBlockElement.appendChild(this.utilityMenuElement);
			}
		}
		else if (this.utilityMenuState === 'mobile') {
			// switch to mobile
			if (!this.mainMenuBlockElement.contains(this.utilityMenuElement)) {
				this.mainMenuBlockElement.appendChild(this.utilityMenuElement);
			}
		}
	}

	addMobileEventListenersToLevel0Items() {
		for (const itemLevel0Element of this.mainMenuItemLevel0Elements) {
			if (this.mainMenuItemLevel0ElementHasMegaMenu(itemLevel0Element)) {
				this.addMobileEventListenersToLevel0Item(itemLevel0Element);
			}
		}
	}

	addMobileEventListenersToLevel0Item(item) {
		const button = item.querySelector(':scope > button');
		if (button) {
			button.addEventListener('click', () => {
				console.log(this.desktopMobileState);
				console.log(button.closest('.menu-item'));
				if (this.desktopMobileState === 'mobile') {
					const menuItemElement = button.closest('.menu-item');
					if (menuItemElement.classList.contains('mobile-link-item-active')) {
						menuItemElement.classList.remove('mobile-link-item-active');
					}
					else {
						menuItemElement.classList.add('mobile-link-item-active');
					}
				}
			});
		}
	}

	mainMenuItemLevel0ElementHasMegaMenu(element) {
		return element.classList.contains('menu-item--expanded');
	}

	// desktop methods

	showSearchBlock() {
		if (this.searchBlockElement) {
			document.body.classList.add('desktop-search-open');
			setTimeout(() => {
				this.searchFormInputElement.focus();
			}, 250);
		}
	}

	hideSearchBlock() {
		if (this.searchBlockElement) {
			document.body.classList.remove('desktop-search-open');
			document.body.classList.remove('mobile-search-open');
		}
	}

	get isSearchBlockOpen() {
		return document.body.classList.contains('desktop-search-open');
	}

	toggleSearchBlock() {
		if (this.searchBlockElement) {
			if (this.isSearchBlockOpen) {
				this.hideSearchBlock();
			}
			else {
				this.showSearchBlock();
			}
		}
	}

	setMegaMenuColumnCounts() {
		for (const itemLevel0Element of this.mainMenuItemLevel0Elements) {
			if (this.mainMenuItemLevel0ElementHasMegaMenu(itemLevel0Element)) {
				const itemLevel1Elements = itemLevel0Element.querySelectorAll(':scope > .menu-dropdown > ul > li');
				itemLevel0Element.style.setProperty('--level-1-items-count', itemLevel1Elements.length);
			}
		}
	}

	setMegaMenuPositions = () => {
		if (!this.constructor.mediaQuery.large.matches) {
			const mainMenuRect = this.mainMenuBlockElement.getBoundingClientRect();
			this.mainMenuBlockElement.style.setProperty('--main-menu-area-width', `${mainMenuRect.width}px`);
			const offsetLeft = mainMenuRect.left; // value to translate rect left into css left for actual style value
			const minimumLeft = mainMenuRect.left; // any less and the mega menu would display outside the left border of the menu block
			for (const itemLevel0Element of this.mainMenuItemLevel0Elements) {
				if (this.mainMenuItemLevel0ElementHasMegaMenu(itemLevel0Element)) {
					const itemLevel0Rect = itemLevel0Element.getBoundingClientRect();
					const dropdownElement = itemLevel0Element.querySelector(':scope > .menu-dropdown');
					const dropdownRect = dropdownElement.getBoundingClientRect();
					const maximumLeft = mainMenuRect.right - dropdownRect.width; // any more and the mega menu would display outside the right border of the menu block
					let leftValue = itemLevel0Rect.left; // set to left of menu item level 0 element
					leftValue = leftValue + (itemLevel0Rect.width / 2); // center under menu item level 0 element
					leftValue = leftValue - (dropdownRect.width / 2) // center the value to the center of the dropdown element
					leftValue = Math.max(leftValue, minimumLeft); // enforce minimum value
					leftValue = Math.min(leftValue, maximumLeft); // enforce maximum value
					leftValue = leftValue - offsetLeft; // apply offset to ground to container left
					dropdownElement.style.setProperty('--mega-menu-left', `${leftValue}px`);
				}
			}
		}
	}

	// mobile methods

	updateMobileOverlayHeight = () => {
		if (this.constructor.mediaQuery.large.matches) {
			const overlayHeight = window.innerHeight - this.siteWideHeaderElement.getBoundingClientRect().bottom;
			this.siteWideHeaderElement.style.setProperty('--mobile-overlay-height', `${overlayHeight}px`);
		}
	}

	openMobileSearch() {
		this.updateMobileOverlayHeight();
		document.body.classList.add('mobile-search-open');
		this.closeMobileMenu(true);
		const isScrollEnabled = noScroll.isScrollEnabled(this.constructor.noScrollOptions);
		if (isScrollEnabled.y) {
			noScroll.disableScroll(this.constructor.noScrollOptions);
		}
	}
	
	closeMobileSearch(isMenuOpening = false) {
		document.body.classList.remove('mobile-search-open');
		document.body.classList.remove('desktop-search-open');
		if (!isMenuOpening) {
			const isScrollEnabled = noScroll.isScrollEnabled(this.constructor.noScrollOptions);
			if (!isScrollEnabled.y) {
				noScroll.enableScroll(this.constructor.noScrollOptions);
			}
		}
	}

	get isMobileSearchOpen() {
		return document.body.classList.contains('mobile-search-open');
	}
	
	toggleMobileSearch = () => {
		if (this.isMobileSearchOpen) {
			this.closeMobileSearch();
		}
		else {
			this.openMobileSearch();
		}
	};
	
	openMobileMenu() {
		this.updateMobileOverlayHeight();
		document.body.classList.add('mobile-menu-open');
		this.closeMobileSearch(true);
		const isScrollEnabled = noScroll.isScrollEnabled(this.constructor.noScrollOptions);
		if (isScrollEnabled.y) {
			noScroll.disableScroll(this.constructor.noScrollOptions);
		}
	}
	
	closeMobileMenu(isSearchOpening = false) {
		document.body.classList.remove('mobile-menu-open');
		if (!isSearchOpening) {
			const isScrollEnabled = noScroll.isScrollEnabled(this.constructor.noScrollOptions);
			if (!isScrollEnabled.y) {
				noScroll.enableScroll(this.constructor.noScrollOptions);
			}
		}
	}

	get isMobileMenuOpen() {
		return document.body.classList.contains('mobile-menu-open');
	}

	toggleMobileMenu = () => {
		if (this.isMobileMenuOpen) {
			this.closeMobileMenu();
		}
		else {
			this.openMobileMenu();
		}
	};

};